export default __webpack_public_path__ + "static/media/image_1.b643df45.png";